import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import {
  FETCH_CONTRACTORS_KEY,
  FETCH_EMPLOYEES_KEY,
  POST_ACCEPT_COMPANY_TOS_KEY,
  POST_MIGRATE_PAYROLL_KEY,
  postAcceptCompanyTOS,
  postMigratePayroll,
} from '../payrollActions'
import { PayrollLoading } from '../run-payroll/PayrollLoading'
import { Button, Card, CardColors, Image, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { getFetchError, selectIsFetchingForKeys } from '@/reducers/fetch'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

const FETCH_KEY_LIST = [
  POST_MIGRATE_PAYROLL_KEY,
  FETCH_EMPLOYEES_KEY,
  FETCH_CONTRACTORS_KEY,
  POST_ACCEPT_COMPANY_TOS_KEY,
]

export const ProcessMigration = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const isFetching = useReselector(selectIsFetchingForKeys, FETCH_KEY_LIST)
  const migrationError = useReselector(getFetchError, POST_MIGRATE_PAYROLL_KEY)

  const errorCopy = migrationError?.message ?? null

  useEffect(() => {
    const migrate = async () => {
      // This page shouldn't be navigated to without the code param
      if (!code) {
        return
      }
      const res = await postMigratePayroll({ code })(dispatch)
      if (res) {
        // User accepted TOS before this page but company wasn't created so do it here once migration completed
        await postAcceptCompanyTOS()(dispatch)
        // Navigate to Dashboard
        navigate('/payroll/run_payroll?migrated=true')
      }
    }

    migrate()
  }, [code, dispatch, navigate])

  return (
    <div className="flex flex-col gap-6">
      <Text variant={TypographyStyles.H1}>Heard Payroll</Text>
      {isFetching && <PayrollLoading text="Fetching your data..." />}
      {migrationError && (
        <Card
          color={CardColors.WARNING}
          className="max-w-lg"
          childrenClassName="flex flex-col gap-6"
        >
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/warning-coin.svg"
            alt="Warning"
            className="h-20 w-20"
          />
          <Text variant={TypographyStyles.BODY_MD}>{errorCopy}</Text>
          <div>
            <Button onClick={() => navigate('/payroll/migrate')}>
              Go back
            </Button>
          </div>
        </Card>
      )}
    </div>
  )
}
